<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏-->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索条件：
                        <el-input size="mini" placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select size="mini" v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option v-for="item in keywordList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV"> <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true" /> </el-button>
                </div>
            </div>
            <div v-show="showFV" >
                <div class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>支付渠道：
                        <el-select clearable v-model="searchVal.payWayCode" placeholder="支付渠道" size="mini" style="width: 120px;margin-right: 15px;">
                            <el-option v-for="item in this._enums.PayWayEnum" :key="item.id" :label="item.name" :value="item.id"/>
                        </el-select>
                    </div>
                    <div>
                        支付方式：
                        <el-select clearable v-model="searchVal.payModeCode" placeholder="支付方式" size="mini" style="width: 120px;margin-right: 15px;">
                            <el-option v-for="item in this._enums.PayModeEnum" :key="item.id" :label="item.name" :value="item.id"/>
                        </el-select>
                    </div>

                    <div>
                        金额范围：
                        <el-input v-model="searchVal.minAmount" size="mini" clearable style="width: 160px;margin-right: 0px;">
                            <span slot="append">元</span>
                        </el-input>
                        -
                        <el-input v-model="searchVal.maxAmount" size="mini" clearable style="width: 160px;margin-right: 15px;">
                            <span slot="append">元</span>
                        </el-input>
                    </div>

                </div>
                <div class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>交易日期： <el-date-picker v-model="searchVal.transDateScope" value-format="yyyy-MM-dd" style="width:250px;margin-right: 15px;" type="daterange" size="mini" unlink-panels start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" /></div>
                    <div>
                        汇总条件：<el-select @change="searchDo" multiple clearable v-model="searchVal.totalTypes" placeholder="请选择汇总条件" size="mini" style="width: 350px;margin-right: 15px;">
                        <el-option
                                v-for="item in this._enums.DevTransTotalTypeEnum"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    </div>
                </div>
            </div>
        </div>
        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="jnl"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%;">
                <el-table-column prop="devInfo.terSn" label="设备SN" width="200" />
                <el-table-column prop="devInfo.modelId" label="型号" width="100" >
                    <template slot-scope="scope">
                        {{getModelNameById(scope.row.devInfo.modelId)}}
                    </template>
                </el-table-column>
                <el-table-column prop="devInfo.inAgentName" label="设备归属" />
                <el-table-column prop="devInfo.inMchName" label="商户" />
                <el-table-column prop="payWayCode" label="支付渠道" align="center" width="80" v-if="-1!==searchVal.totalTypes.indexOf(this._enums.DevTransTotalTypeEnum.支付渠道.id)" >
                    <template slot-scope="scope">
                        {{_enums.PayWayEnum.getNameById(scope.row.payWayCode)}}
                    </template>
                </el-table-column>
                <el-table-column prop="payModeCode" label="支付方式" align="center" width="80" v-if="-1!==searchVal.totalTypes.indexOf(this._enums.DevTransTotalTypeEnum.支付方式.id)" >
                    <template slot-scope="scope">
                        {{_enums.PayModeEnum.getNameById(scope.row.payModeCode)}}
                    </template>
                </el-table-column>
                <el-table-column prop="paySuccTime" label="交易日期" align="center" width="100" :formatter="funDateFormatter" v-if="-1!==searchVal.totalTypes.indexOf(this._enums.DevTransTotalTypeEnum.交易日期.id)" />
                <el-table-column prop="amount" label="交易金额" align="right" :formatter="funFmtTransAmt" sortable />
                <el-table-column prop="cnt" label="交易笔数" align="center" width="120" sortable />
            </el-table>

        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="height:32px;line-height: 32px; font-family: 'Arial Black'; font-size: 15px; background-color:green; color: white; padding-left: 15px;padding-right: 15px; ">{{msgInfo}}</div>
            <div class="yx-flex-h-end">
                <!--
                <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
                -->
                <el-pagination
                        :current-page.sync="page"
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev,pager,next, jumper,->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        name: "RptAllMchTraTot", //服务商设备交易汇总
        data() {
            return {
                loading: false,
                showFV: false,
                total: 0,
                msgInfo: 0,
                page: 1,
                size: 10,
                jnl: [],
                keywordList: [
                    {id:"devInfo.terSn",name:"设备序列号"},
                    {id:"devInfo.inAgentName",name:"服务商名称"},
                ],
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    totalTypes : [],
                    payWayCode : null,
                    payModeCode : null,
                    transDateScope : null,
                    minAmount: null,
                    maxAmount: null
                },
            }
        },
        mounted() {
            this.initJnl();
        },
        methods: {
            searchReset() {
                this.searchVal = {};
                this.searchVal.totalTypes = [];
            },
            searchDo() {
                this.page = 1;
                this.initJnl();
            },
            initJnl() {
                this.loading = true;
                let url = '/rpt/comp/devTransTotalsAll?page=' + this.page + '&size=' + this.size;
                if (this.searchVal.totalTypes)
                    url += '&totalTypes=' + this.searchVal.totalTypes;
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.payWayCode)
                    url += '&payWayCode=' + this.searchVal.payWayCode;
                if (this.searchVal.payModeCode)
                    url += '&payModeCode=' + this.searchVal.payModeCode;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                if (this.searchVal.minAmount)
                    url += '&minAmount=' + this.searchVal.minAmount;
                if (this.searchVal.maxAmount)
                    url += '&maxAmount=' + this.searchVal.maxAmount;

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.jnl = resp.data;
                        this.total = resp.total;
                        this.msgInfo = resp.msgInfo;
                    }
                });
            },
            exportData() {

                let url = '/rpt/comp/devTransTotalsAll/export?page=1';
                if (this.searchVal.totalTypes)
                    url += '&totalTypes=' + this.searchVal.totalTypes;
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.payWayCode)
                    url += '&payWayCode=' + this.searchVal.payWayCode;
                if (this.searchVal.payModeCode)
                    url += '&payModeCode=' + this.searchVal.payModeCode;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                if (this.searchVal.minAmount)
                    url += '&minAmount=' + this.searchVal.minAmount;
                if (this.searchVal.maxAmount)
                    url += '&maxAmount=' + this.searchVal.maxAmount;

                window.open(url, '_parent');
            },
            funFmtTransAmt(row, column) {
                return row.amount.toFixed(2);
            },
            funFmtTemp(row, column) {
                return '0.00';
            },
            // 日期格式化
            funDateFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(0,10);
                }
                return tm;
            },
            // 时间格式化
            funTimeFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(11,19);
                }
                return tm;
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initJnl();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initJnl();
            },
            getModelNameById(id) {
                if(this.$root.g_data_dev_model!==null) {
                    for(let i=0;i<this.$root.g_data_dev_model.length;i++) {
                        if(id===this.$root.g_data_dev_model[i].id)
                            return this.$root.g_data_dev_model[i].model;
                    }
                }
                return '未知型号';
            }
        }
    }
</script>

<style>

</style>
